import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import InfoIcon from '@material-ui/icons/Info';

const useStyles = makeStyles((theme) => ({
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        border: "2px solid #00567a",
        borderRadius: "8px",
        boxShadow: theme.shadows[5],
        padding: "8px 16px 16px",
        maxHeight: `95vh`,
        width: '75vw',
        overflow: 'auto',
        outline: "none"
    },
}));

const ModalImages = props => {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const createMarkup = props => {
        return { __html: props };
    };

    const body = (
        <div 
            className={classes.paper}
        >
            <h3 id="simple-modal-title" className="margin-top-4" style={{color: props.color}}>{props.title} Images</h3>
            <div 
                id="simple-modal-description" 
                style={{fontSize: "1rem"}}
            >
                {props.qImages.map((item, index) => {
                    let alt = props.title + ' image ' + index;
                    let _img = ''

                    if (typeof item === 'object') { _img = item.imageURL } else { _img = item }
                    return (
                        <>
                            <div
                                className="flex-col-start width100"
                            >
                                <div className="image-container">
                                    <img src={_img} alt={alt} classnName=""/>
                                </div>
                            </div>
                        </>
                    )}
                )}
            </div>
        </div>
    );

    return(
        <div>
            <button type="button" className="button-text" onClick={handleOpen} style={{color: "#00567a", padding: "0 20px 16px", fontSize:"0.9em", fontWeight: "700"}}>
                View Images
            </button>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{
                    display:"flex",
                    flexDirection:"column",
                    justifyContent:"center",
                    alignItems:"center"
                }}
            >
                {body}
            </Modal>
        </div>
    )
}

export default ModalImages;